import { createContext, useContext, useState } from "react";

const PrintContext = createContext(null);

export const PrintProvider = ({ children }) => {
  const [payload, setPayload] = useState(null);

  return (
    <PrintContext.Provider value={{ payload, setPayload }}>
      {children}
    </PrintContext.Provider>
  );
};

export const usePrint = () => useContext(PrintContext);
